$(document).ready(function(){

    $('#ship-to-different-address-checkbox').change(function(){
        if($(this).is(':checked')) {
            $('.shipping_address').slideDown();
        }else{
            $('.shipping_address').slideUp();
        }
    })

    $('#shipping_country').change(function(){
        $(document.body).trigger('update_checkout');
    });

    checkCompanyFieldsCheckbox();
    function checkCompanyFieldsCheckbox(){
        let checkbox = $('#billing_company_checkbox');
        if(checkbox.is(':checked')){
            $('.checkout-company-field').slideDown();
            $('#billing_company_checkbox_field label').addClass('custom-checkbox-checked');
        }
    }

    /* nakupujem na firmu checkout zobraz inputy */
    $('#billing_company_checkbox_field label.checkbox').click(function(){
        if($('#billing_company_checkbox').is(':checked')) {
            $('#billing_company_checkbox_field label').addClass('custom-checkbox-checked');
            $('.checkout-company-field').slideDown();
        }else{
            $('#billing_company_checkbox_field label').removeClass('custom-checkbox-checked');
            $('.checkout-company-field').slideUp();
        }
    })

})

/* packeta */
$(document).on('click', '.select-packeta-pobocka', function(){
    let current_country = $('#billing_country').val().toLowerCase();
    let packetaApi = $('#packeta_api').val();
    let packet_options = {
        language: $('#current_language').val() ?? 'sk',
        country: current_country,
    };
    Packeta.Widget.pick(packetaApi, user_selected_branch, packet_options);
});

function user_selected_branch(branch_data) {
    if(branch_data){
        let branch_name = branch_data.place + ', ' + branch_data.name;
        $('#billing_packeta_branch_id').val(branch_data.id);
        $('#billing_packeta_branch_name').val(branch_name);
        $('.js-packeta-selected-branch-name').html('<p>'+branch_name+'</p>');
        save_branch_to_user(branch_data.id, branch_name);
    }
}

function save_branch_to_user(branch_id, branch_name){
    if(branch_id && branch_name){
        $.ajax({
            type:     'POST',
            url:      BASE_URL+'/wp-admin/admin-ajax.php',
            dataType: 'html',
            data: {
                'action': 'save_packeta_branch_to_user',
                'branch_id': branch_id,
                'branch_name'  : branch_name
            }
        });
    }
}

$(document).on('click', '#order_review .woocommerce-remove-coupon',function(){
    let remove_coupon_button = $(this);
    setTimeout(
        function() {
            notif('warning', remove_coupon_button.data('success-text'));
            $( document.body ).trigger( 'update_checkout' );
        }, 700
    );
});

$(document).on('click', '.js-checkout-add-coupon',function(){

    //let add_coupon_button = $(this);
    let checkout_coupon_input = $('#checkout-coupon-input');
    let value = checkout_coupon_input.val();
    if(!value){
        checkout_coupon_input.css('border', '1px solid red');
        notif('danger', $(this).attr('data-error-msg'));
    }else{
        $('#coupon_code').val(value);
        $('.js-apply-coupon-button').click();

        setTimeout(
            function() {
                // notif('success', add_coupon_button.attr('data-success-msg'));
                $( document.body ).trigger( 'update_checkout' );
            }, 700
        );
    }
})
$( document ).on('change', 'input[name="payment_method"]', function() {
    $( document.body ).trigger( 'update_checkout' );
});

/* prepinanie heureka overene checkout */
$(document).on('change', '#heureka_checkbox', function(){
    if($(this).is(':checked')){
        $('#billing_heureka_overene').val(1);
    }else{
        $('#billing_heureka_overene').val(0);
    }
})
/* ak nie je vyplnene pobocka packety */
$(document).on('click', '#place_order', function(){
    const selected_method = $('#shipping_method input.shipping_method:checked');

    if(selected_method.hasClass('js-is-branch-pick'))  {
        if( !$('#billing_packeta_branch_id').val() ){
            notif( 'danger', $('.js-packeta-selected-branch-name').attr('data-error-text'));
            return false;
        }
    }
})

$('.woocommerce-checkout').on('keypress', function(e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode === 13) {
        if( $('#checkout-coupon-input').is(':focus')){
            $('.js-checkout-add-coupon').click();
        }
        e.preventDefault();
        return false;
    }
});
